export default function NoMatch() {

  return (
    <div id="error-container">
      <div id='error-404'>
        
        <div id="error-header-container">
          <h1 className="thrasher" id="error-header">Error 404</h1>
        </div>

        <h2 className="thrasher">Path not found</h2>
      </div>
    </div>
  )
}